<template>
    <a class="snipcart-add-item"
      v-on:click="trackClick"
      :data-item-id="item.id"
      :data-item-price="item.price"
      data-item-url="/static/v1/products.json"
      :data-item-description="item.description"
      :data-item-image="item.image_url"
      data-item-custom1-name="Color"
      :data-item-custom1-options="`Solid ${item.color}|Transparent ${item.color}`"
      :data-item-name="`${item.name}`">
    <i class="ti-shopping-cart"></i>
    </a>
</template>
<script>
export default {
  name: 'BuyIcon',
  props: ['item'],
  methods: {
    trackClick (e) {
      let cartSize = window.Snipcart.store.getState().cart.items.items.length + 1
      let metadata = {
        cartSize,
        type: 'icon'
      }
      let properties = {...metadata, ...this.item}
      window.analytics.track('Add to Cart', properties)
      window.gtag('event', 'select_content', {
        'content_type': 'product',
        'items': [this.item]
      })
    }
  }
}
</script>
<style scoped>
.snipcart-add-item {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/BuyIcon.vue